import { render, staticRenderFns } from "./AprovacaoSolicitacaoControls.vue?vue&type=template&id=1cb9b5d2&"
import script from "./AprovacaoSolicitacaoControls.vue?vue&type=script&lang=js&"
export * from "./AprovacaoSolicitacaoControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
